import React from 'react';
import PropTypes from 'prop-types';
import { numberFormatter } from '../../../../utils/number';
import { parcelOtherIncomesSummaryPropTypes } from './SalesSessionPropTypes';
import Table from '../../../common/Table';
import CollapsibleHeader from '../../../layout/CollapsibleHeader';
import OtherIncomesParcelsTable from './OtherIncomesParcelsTable';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import { Col, Row } from 'reactstrap';
import Badge from '../../../common/Badge';

const ParcelOtherIncomesSummary = ({
  parcelOtherIncomesSummaryList,
  parcelOtherIncomeSummaryBySerieList,
  salesSessionId,
}) => {
  let totalAmount = 0;
  parcelOtherIncomesSummaryList.forEach((parcel) => {
    totalAmount += parcel.totalAmount;
  });

  const clearVoucherPrefix = (serie) => {
    if (serie && (serie.startsWith('B') || serie.startsWith('F'))) {
      return serie.substring(1);
    }
    return serie;
  };

  const getParsedDocumentSeries = (parcelIncomeSummary) => {
    if (parcelIncomeSummary.contingency) {
      return clearVoucherPrefix(parcelIncomeSummary.documentSeries);
    }
    return parcelIncomeSummary.documentSeries;
  };

  if (!parcelOtherIncomeSummaryBySerieList.length) {
    return null;
  }
  return (
    <>
      <hr />
      <CollapsibleHeader
        headerText="Otros Ingresos de Cargo"
        component={OtherIncomesParcelsTable}
        salesSessionId={salesSessionId}
      />
      <Row>
        <Col>
          <Table
            columns={[
              {
                Header: 'Tipo de Comprobante de Pago',
                accessor: 'voucherType',
                className: 'text-center',
                Cell: (row) => {
                  if (row.original.contingency) {
                    const text = row.value.replace(/electronica/gi, '');
                    return (
                      <>
                        {text} -{' '}
                        <Badge
                          className={'bg-secondary text-white'}
                          text="Contingencia"
                        />
                      </>
                    );
                  }
                  return <>{row.value}</>;
                },
              },
              {
                Header: 'Serie',
                accessor: 'documentSeries',
                className: 'text-center',
                Cell: (row) => {
                  return getParsedDocumentSeries(row.original);
                },
              },
              {
                Header: 'Total de Ventas',
                accessor: 'totalAmount',
                Cell: ({ value }) => numberFormatter({ value }),
                Footer: (row) =>
                  `Total: ${numberFormatter({
                    value: row.data.reduce(
                      (accumulated, data) => accumulated + data.totalAmount,
                      0,
                    ),
                  })}`,
                className: 'text-right',
              },
            ]}
            data={parcelOtherIncomeSummaryBySerieList}
            defaultPageSize={parcelOtherIncomeSummaryBySerieList.length}
            showPagination={false}
          />
        </Col>
      </Row>
      <br />
      {parcelOtherIncomesSummaryList.map((paymentMethodSales) => (
        <ResourceProperty
          key={paymentMethodSales.moneyFlowConcept}
          label={`${paymentMethodSales.moneyFlowConcept}: `}
        >
          {numberFormatter({ value: paymentMethodSales.totalAmount })}
        </ResourceProperty>
      ))}
      <ResourceProperty label="Total de Otros Ingresos de Cargo: ">
        {numberFormatter({ value: totalAmount })}
      </ResourceProperty>
    </>
  );
};

ParcelOtherIncomesSummary.propTypes = {
  parcelOtherIncomesSummaryList: parcelOtherIncomesSummaryPropTypes.isRequired,
  parcelOtherIncomeSummaryBySerieList: parcelOtherIncomesSummaryPropTypes.isRequired,
  salesSessionId: PropTypes.number.isRequired,
};

export default ParcelOtherIncomesSummary;
